import { createSelector } from 'reselect';
import includes from 'lodash/includes';
import * as constants from './constants';
import * as actionTypes from './actionTypes';
/**
 * Input selectors
 */ const mainSelector = (state)=>state[constants.MODULE_ID];
const sccSelector = (state)=>state[constants.MODULE_ID].scc;
const fetchingSelector = (state)=>state[constants.MODULE_ID].fetching;
const sendingSelector = (state)=>state[constants.MODULE_ID].sending;
const errorsSelector = (state)=>state[constants.MODULE_ID].errors;
//----------------------------------------------------------------------------------------------------------------------
/**
 * Imported device data
 */ export const deviceData = (state)=>mainSelector(state).deviceData;
export const hasDevicePatientBeenResolved = (state)=>mainSelector(state).hasDevicePatientBeenResolved;
export const deviceDataType = (state)=>mainSelector(state).deviceDataType;
export const status = (state)=>mainSelector(state).status;
export const connectorType = (state)=>mainSelector(state).connectorType;
export const connectionId = (state)=>mainSelector(state).connectionId;
export const connectionStatus = (state)=>mainSelector(state).connectionStatus;
export const connectionError = (state)=>mainSelector(state).connectionError;
export const serialNumber = (state)=>{
    var _deviceData;
    return (_deviceData = deviceData(state)) === null || _deviceData === void 0 ? void 0 : _deviceData.serialNumber;
};
/**
 * Tray downloader
 */ export const downloader = (state)=>mainSelector(state).downloader;
// SCC -----------------------------------------------------------------------------------------------------------------
/**
 * Sinovo Connection Center
 */ export const scc = (state)=>sccSelector(state);
/**
 * Sinovo Connection Center machine ID that specifies physical device on which downloader app is running.
 */ export const sccMachineId = (state)=>sccSelector(state).machineId;
/**
 * Sinovo Connection Center pairing code that is used to connection between browser and tray application
 */ export const sccPairingCode = (state)=>sccSelector(state).pairingCode;
/**
 * Sinovo Connection Center status that specifies if application is waiting for a job, processing or not responding
 */ export const sccStatus = (state)=>sccSelector(state).status;
/**
 * Sinovo Connection Center job status that specifies on what stage is requested job
 */ export const sccJobStatus = (state)=>sccSelector(state).jobStatus;
//----------------------------------------------------------------------------------------------------------------------
export const isCheckDownloaderInProgress = createSelector(fetchingSelector, (state)=>includes(state, actionTypes.CHECK_STATUS) || includes(state, actionTypes.CHECK_BLUE_CABLE_DRIVER));
//----------------------------------------------------------------------------------------------------------------------
export const isInstallDownloaderInProgress = createSelector(fetchingSelector, (state)=>includes(state, actionTypes.INSTALL_DOWNLOADER));
//----------------------------------------------------------------------------------------------------------------------
export const isSendBluetoothPinInProgress = createSelector(sendingSelector, (state)=>includes(state, actionTypes.SEND_BLUETOOTH_PIN));
export const hasSendBluetoothPinErrors = createSelector(errorsSelector, (state)=>includes(state, actionTypes.SEND_BLUETOOTH_PIN));
//----------------------------------------------------------------------------------------------------------------------
export const isCheckSccInProgress = createSelector(fetchingSelector, (state)=>includes(state, actionTypes.CHECK_SCC_STATUS));
//----------------------------------------------------------------------------------------------------------------------
export const isDownloaderUpdated = (state)=>mainSelector(state).isDownloaderUpdated;
//----------------------------------------------------------------------------------------------------------------------
export const isUpdatingSelector = (state)=>mainSelector(state).isUpdating; //----------------------------------------------------------------------------------------------------------------------
